/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import $ from 'jquery'
import jMoment from 'moment-jalaali'
import cookie from 'react-cookies'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Pageing from '../Pagination/pageing'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import TMS from '../BaseComponent/TMS'
import FromToPicker from '../BaseComponent/FromToPicker'
import {convertMinuteToHour, roundTo} from '../utils/convert'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'
import {message} from 'antd'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {Bar} from 'react-chartjs-2'
import Loader from '../loaders/loader'

class ActivityFunctionality extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      list: [],
      printInfo: [],
      lengthProducts: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      getSort: '',
      modalDelete: false,
      fromDate: '',
      toDate: '',
      sortData: [
        {name: 'ردیف', value: 'id', sorted: false, direction: null, sortable: false},
        {name: 'عنوان', value: 'title', sorted: false, direction: null, sortable: false},
        {name: 'حداقل زمان ', value: 'timeMinuteMin', sorted: false, direction: null, sortable: true},
        {name: 'میانگین زمان ', value: 'timeMinuteAvg', sorted: false, direction: null, sortable: true},
        {name: 'حداکثر زمان ', value: 'timeMinuteMax', sorted: false, direction: null, sortable: true},
        {name: 'تعداد فعالیت', value: 'activityCount', sorted: false, direction: null, sortable: true},
        {name: 'تعداد روز کاری', value: 'dayCount', sorted: false, direction: null, sortable: true},
        {name: 'مدت زمان اعلامی ', value: 'timeMinuteUser', sorted: false, direction: null, sortable: true},
        {
          name: 'مدت زمان تایید شده ',
          value: 'timeMinuteOperatorAccept',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'مدت زمان تایید نشده ',
          value: 'timeMinuteOperatorReject',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'مدت زمان بررسی نشده ',
          value: 'timeMinuteOperatorDraft',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نسبت تایید شده ها به کل ',
          value: 'timeMinuteOperatorAcceptRatio',
          sorted: false,
          direction: null,
          sortable: true
        },
        {name: 'جزییات', value: '', sorted: false, direction: null, sortable: false}
        // {name : 'نمودار', value : '' , sorted : false ,direction : null,sortable : false},
      ],
      department: [],
      operators: [],
      personId: {
        personId: ''
      },
      detailsModal: false,
      detailsData: []
    }
  }
  convertCount = (count) => {
    if (count !== null) {
      return count.toFixed(1).replace('.0', '')
    } else {
      return ''
    }
  }

  getAll = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${TMS.TMS_REPORT_ACTIVITY_FUNCTIONALITY}`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          console.log(res.data.object.result)
          $('.showBaseTable').fadeIn()

          if (!exportStatus) {
            this.setState({
              list: res.data.object.result,
              lengthProducts: res.data.object.countAll,
              loading: false
            })
          } else if (exportStatus) {
            this.setState({
              printInfo: res.data.object.result,
              loading: false
            })
          }
        } else {
          $('.showBaseTable').fadeOut()
          this.setState({
            loading: false
          })
        }
      })
      .catch(
        this.setState({
          loading: false
        })
      )
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.basketFilterComponent').slideUp()
      })
    })
    // this.getAll(false)
    http.get(`${TMS.TMS_MANAGE_BASE_ORGANIZATION_LIST}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          department: response.data.object
        })
      }
    })

    http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object
        })
      }
    })
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAll(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAll(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAll(false)
    }
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let grouping = $('#grouping').val()
    let departmentId = $('#departmentId').val()
    let activityDateMin = this.state.fromDate
    let activityDateMax = this.state.toDate
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (grouping !== '' && grouping.length) {
      filter.grouping = grouping
    }
    if (activityDateMin !== '') {
      filter.activityDateMin = activityDateMin
    }
    if (departmentId !== '' && departmentId.length) {
      filter.departmentId = departmentId
    }
    if (this.state.personId !== '') {
      filter.personId = this.state.personId.personId
    }

    if (activityDateMax !== '') {
      filter.activityDateMax = activityDateMax
    }

    return filter
  }

  filter() {
    let grouping = $('#grouping').val()
    let departmentId = $('#departmentId').val()
    let activityDateMin = this.state.fromDate
    let activityDateMax = this.state.toDate
    if (grouping === 'user') {
      sessionStorage.setItem(
        'params',
        `activityDateMax=${activityDateMax}&activityDateMin=${activityDateMin}&departmentId=${departmentId}&personId=`
      )
    } else if (grouping === 'department') {
      sessionStorage.setItem(
        'params',
        `activityDateMax=${activityDateMax}&activityDateMin=${activityDateMin}&departmentId=${departmentId}`
      )
    } else if (grouping === 'section') {
      sessionStorage.setItem(
        'params',
        `activityDateMax=${activityDateMax}&activityDateMin=${activityDateMin}&departmentId=${departmentId}&sectionId=`
      )
    } else if (grouping === 'task') {
      sessionStorage.setItem(
        'params',
        `activityDateMax=${activityDateMax}&activityDateMin=${activityDateMin}&taskId=${departmentId}`
      )
    } else {
      sessionStorage.setItem(
        'params',
        `activityDateMax=${activityDateMax}&activityDateMin=${activityDateMin}&departmentId=`
      )
    }

    this.setState(
      {
        pageNumber: 1
      },
      () => {
        this.getAll(false)
      }
    )
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${TMS.TMS_REPORT_ACTIVITY_FUNCTIONALITY}`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          let result = res.data.object.result
          for (let i in result) {
            result[i].timeMinuteMin = convertMinuteToHour(result[i].timeMinuteMin)
            result[i].activityCount = this.convertCount(result[i].activityCount)
            result[i].timeMinuteAvg = convertMinuteToHour(result[i].timeMinuteAvg)
            result[i].timeMinuteMax = convertMinuteToHour(result[i].timeMinuteMax)
            result[i].timeMinuteUser = convertMinuteToHour(result[i].timeMinuteUser)
            result[i].timeMinuteOperatorAccept = convertMinuteToHour(result[i].timeMinuteOperatorAccept)
            result[i].timeMinuteOperatorReject = convertMinuteToHour(result[i].timeMinuteOperatorReject)
            result[i].timeMinuteOperatorDraft = convertMinuteToHour(result[i].timeMinuteOperatorDraft)
            result[i].timeMinuteOperatorAcceptRatio = roundTo(result[i].timeMinuteOperatorAcceptRatio)
          }
          this.setState({
            excelReport: res.data.object.result
          })

          this._export.save(this.state.excelReport)
        }
      })
  }

  getPrintInfo = () => {
    this.getAll(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }
  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getValueOperator = (personId) => {
    if (personId === null) {
      this.setState({
        personId: ''
      })
    } else {
      this.setState({
        personId
      })
    }
  }

  statusColor = (timeMinuteUser, taskTimeMinuteMin, taskTimeMinuteMax, count) => {
    if (timeMinuteUser < taskTimeMinuteMin * count) {
      return '#d4fcc3'

      //red
    } else if (timeMinuteUser > taskTimeMinuteMax * count) {
      return '#fbd9d9'
    } else {
      return ''
    }
  }
  convertState = (state) => {
    switch (state) {
      case 100:
        return 'در انتظار'
        break
      case 10:
        return <img src={require('../../image/confirm.svg')} style={{width: '20px'}} />
        break
      case 20:
        return <img src={require('../../image/ignor.svg')} style={{width: '20px'}} />
        break
      default:
        return '-'
    }
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'عنوان',
      'حداقل زمان',
      'میانگین زمان',
      'حداکثر زمان',
      'تعداد فعالیت',
      'تعداد روزکاری',
      'مدت زمان اعلامی',
      'مدت زمان تایید شده',
      'مدت زمان تایید نشده',
      'مدت زمان بررسی نشده',
      'نسبت تایید شده ها به کل'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش عملکرد"
              headerColSpan={13}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={8}
              rightColSpan={4}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{list.title}</td>
                  <td>{convertMinuteToHour(list.timeMinuteMin)}</td>
                  <td>{convertMinuteToHour(list.timeMinuteAvg)}</td>
                  <td>{convertMinuteToHour(list.timeMinuteMax)}</td>
                  <td>{this.convertCount(list.activityCount)}</td>
                  <td>{list.dayCount}</td>
                  <td>{convertMinuteToHour(list.timeMinuteUser)}</td>
                  <td>{convertMinuteToHour(list.timeMinuteOperatorAccept)}</td>
                  <td>{convertMinuteToHour(list.timeMinuteOperatorReject)}</td>
                  <td>{convertMinuteToHour(list.timeMinuteOperatorDraft)}</td>
                  <td>{roundTo(list.timeMinuteOperatorAcceptRatio)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            ref={(exporter) => {
              this._export = exporter
            }}
            dir="rtl"
            fileName="گزارش عملکرد.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'title'}
                field={'title'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'timeMinuteMin'}
                field={'timeMinuteMin'}
                title={'حداقل زمان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteAvg'}
                field={'timeMinuteAvg'}
                title={'میانگین زمان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteMax'}
                field={'timeMinuteMax'}
                title={'حداکثر زمان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'activityCount'}
                field={'activityCount'}
                title={'تعداد فعالیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'activityCount'}
                field={'dayCount'}
                title={'کارکرد روزانه'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteUser'}
                field={'timeMinuteUser'}
                title={'مدت زمان اعلامی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteOperatorAccept'}
                field={'timeMinuteOperatorAccept'}
                title={'مدت زمان تایید شده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteOperatorReject'}
                field={'timeMinuteOperatorReject'}
                title={'مدت زمان تایید نشده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'timeMinuteOperatorDraft'}
                field={'timeMinuteOperatorDraft'}
                title={'مدت زمان بررسی نشده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'timeMinuteOperatorAcceptRatio'}
                field={'timeMinuteOperatorAcceptRatio'}
                title={'نسبت تایید شده ها به کل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>مدیریت فعالیت ها</li>
            <li>گزارشات</li>
            <li>گزارش عملکرد</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel=" تاریخ فعالیت از"
                  toLabel=" تاریخ فعالیت تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label>گروهبندی</label>
                  <select className="form-control" id="grouping">
                    <option value="">------</option>
                    <option value="user" selected>
                      کاربر
                    </option>
                    <option value="department">دپارتمان</option>
                    <option value="section">واحد سازمانی</option>
                    <option value="task">وظیفه</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    دپارتمان
                  </label>
                  <select className="custom-select" name="departmentId" id="departmentId">
                    <option value="">------</option>
                    {this.state.department.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.operators}
                    getValueCombo={this.getValueOperator}
                    lableText="کاربران"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
                <span className="text-danger font-weight-bold mx-2 d-inline-block mt-2">
                  تمامی زمان ها بر حسب ساعت میباشد
                </span>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr>
                    <td colSpan={2} />
                    <td colSpan={3}>مدت زمان مورد انتظار</td>
                    <td colSpan={8}>عملکرد کاربر</td>
                  </tr>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.list.map((list, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{list.title}</td>
                      <td>{convertMinuteToHour(list.timeMinuteMin)}</td>
                      <td>{convertMinuteToHour(list.timeMinuteAvg)}</td>
                      <td>{convertMinuteToHour(list.timeMinuteMax)}</td>
                      <td>{this.convertCount(list.activityCount)}</td>
                      <td>{list.dayCount}</td>
                      <td>{convertMinuteToHour(list.timeMinuteUser)}</td>
                      <td>{convertMinuteToHour(list.timeMinuteOperatorAccept)}</td>
                      <td>{convertMinuteToHour(list.timeMinuteOperatorReject)}</td>
                      <td>{convertMinuteToHour(list.timeMinuteOperatorDraft)}</td>
                      <td>{roundTo(list.timeMinuteOperatorAcceptRatio)}</td>
                      <td>
                        <Link
                          to={`/detailsFunctionality?id=${list.id}&fromDate=${this.state.fromDate}&toDate=${
                            this.state.toDate
                          }`}
                          target={'_blank'}
                        >
                          <img src={require('../../image/details.svg')} />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthProducts}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.detailsModal} toggle={() => this.setState({detailsModal: false})} size="lg">
          <ModalHeader toggle={() => this.setState({detailsModal: false})}>جزییات گزارش عملکرد</ModalHeader>
          <ModalBody>
            <div className="d-flex justify-content-between">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>کاربر</td>
                    <td>دپارتمان</td>
                    <td>بخش</td>
                    <td>فعالیت</td>
                    <td>تامین کننده</td>
                    <td>کالا</td>
                    <td>بازه زمانی</td>
                    <td>وضعیت</td>
                    <td>تاریخ ثبت</td>
                    <td>تعداد</td>
                    <td>تاریخ فعالیت</td>
                    <td>زمان تخمینی</td>
                    <td>زمان مورد تایید</td>
                    <td>توضیحات</td>
                    {/*<td>تعیین وضعیت</td>*/}
                    {/*<td>تاریخچه</td>*/}
                  </tr>
                  {this.state.detailsData.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: this.statusColor(
                          item.timeMinuteUser,
                          item.taskTimeMinuteMin,
                          item.taskTimeMinuteMax,
                          item.count
                        )
                      }}
                    >
                      <td>{index + 1}</td>
                      <td>{item.user !== null && item.user.name}</td>
                      <td>{item.departmentTitle}</td>
                      <td>{item.sectionTitle}</td>
                      <td>{item.taskTitle}</td>
                      <td>{item.providerTitle}</td>
                      <td>{item.productTitle}</td>
                      <td>{item.taskTimeMinuteMin + ' - ' + item.taskTimeMinuteMax + ' دقیقه '}</td>
                      <td>{this.convertState(item.state)}</td>
                      <td>{jMoment(item.creationTime).format('jYYYY/jMM/jDD')}</td>
                      <td>{item.count}</td>
                      <td>{jMoment(item.activityDate).format('jYYYY/jMM/jDD')}</td>
                      <td>{item.timeMinuteUser + ' دقیقه '}</td>
                      <td>{item.state === 10 && item.timeMinuteOperator + ' دقیقه '}</td>

                      <td title={item.description}>{item.description !== null && item.description.substr(0, 5)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({detailsModal: false})}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default ActivityFunctionality
